import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ChatbotInterceptor implements HttpInterceptor {

  constructor() { }

  private static CHATBOT_BASE_PATH: string = "/chatbot/chat/";

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // This condition should be enough since there are only two kind of POST request for che chatbot and only one can
    // contains the / after "chat".
    if (!req.url.includes(ChatbotInterceptor.CHATBOT_BASE_PATH) || req.method !== "POST") {
      return next.handle(req);
    }
    const identityEncoding = req.clone({
      setHeaders: {
        'Accept-Encoding': "identity",
      },
    });

    return next.handle(identityEncoding);
  }
}
